export class DatosUsuario {
    nombre: string = '';
    mail1: string = '';
    mail2: string = '';
    fono: string = '';
    relacion: string = '';
    id: string = '';
    codigoSeguridad: string = '';
}